import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { killEvent } from 'event-helpers';

import TableView from './TableView';
import TablePositionBase from './TablePositionBase';
import { CustomCheckbox } from '../Widgets/Components';

import styles from './Table.scss';

function contains(source, value) {
    return source.indexOf(value) !== -1;
}

const { cellPositions } = TableView;

export default class TableHeader extends TablePositionBase {
    static displayName = displayName('TableView/TableHeader');

    static propTypes = {
        ...TablePositionBase.propTypes,
        columnSelector: PropTypes.shape({
            activeColumns: PropTypes.array.isRequired,
            disabledColumns: PropTypes.array.isRequired,
            allColumns: PropTypes.array.isRequired,
            localizedNames: PropTypes.object.isRequired,
            onChange: PropTypes.func.isRequired,
        }),
    };

    static defaultProps = {
        ...TablePositionBase.defaultProps,
        componentClass: 'table-header',
        position: cellPositions.HEADER,
    };

    componentDidMount() {
        this.updateColumnSelector();
    }

    onContextMenu = (e) => {
        const { columnSelector } = this.props;
        const { toggleColumnSelectorVisibility } = this.context;
        if (columnSelector) {
            killEvent(e);

            toggleColumnSelectorVisibility({ top: e.clientY, left: e.clientX });
        }
    };

    renderColumnSelector() {
        const {
            columnSelector: { activeColumns, disabledColumns, allColumns, localizedNames, onChange },
        } = this.props;

        const renderList = allColumns.map((column) => {
            const isChecked = contains(activeColumns, column);
            const isDisabled = contains(disabledColumns, column);

            return {
                id: column,
                value: (
                    <span className="column-selector-row">
                        <CustomCheckbox type="small" isDisabled={isDisabled} isChecked={isChecked} />
                        {localizedNames[column]}
                    </span>
                ),
                forceDisabled: isDisabled,
            };
        });

        const newOnChange = (widgetId, selectedValue) => {
            onChange(widgetId, selectedValue);
            this.contextMenuChanged = true;
        };

        return {
            widgetId: 'columnSelector',
            type: 'small',
            reset: true,
            onSelectedValue: newOnChange,
            list: renderList,
        };
    }

    updateColumnSelector = () => {
        const { columnSelector } = this.props;
        const { setColumnSelectorContent } = this.context;

        if (columnSelector) {
            setColumnSelectorContent(this.renderColumnSelector());
        }
    };

    componentDidUpdate() {
        if (this.contextMenuChanged) {
            this.updateColumnSelector();
            this.contextMenuChanged = false;
        }
    }

    renderBody(props) {
        const { componentClass, children } = this.props;

        return (
            <thead className={styles[componentClass]} onContextMenu={this.onContextMenu} {...props}>
                {children}
            </thead>
        );
    }
}
